import DataRoomChooseNdaModal from './DataRoomChooseNdaModal.component';

export default DataRoomChooseNdaModal;